module.exports = __webpack_public_path__ + "static/media/1.e37cfd1c.png";